import { useContext } from 'react'
import NewspaperConfigContext from './NewspaperConfigContext'

const useNewspaperConfig = () => useContext(NewspaperConfigContext)

export default useNewspaperConfig
